import { mapState, mapActions } from '../../../store/helpers';
import * as TYPES from '../_store/types';
import { DATA_TYPE_MAP } from '../_conf';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    i18next: {
        ns: 'md-search-bar'
    },
    props: {
        kee: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState({
            ui: store => store.uiConfig
        }),
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency.symbol
        }),
        isSqft() {
            const ui = this.ui[this.kee];
            if (!ui || ui.sqft === undefined) {
                return true; 
            }
            return ui && ui.sqft === 'sqft';
        },
        isAdvanced() {
            const ui = this.ui[this.kee];
            return ui && ui.advanced === 'advanced';
        },
        dataType() {
            const mask = this.data.mask;
            return DATA_TYPE_MAP[mask?.mask] || DATA_TYPE_MAP.none;
        },
        needAdvanced() {
            return this.dataType === DATA_TYPE_MAP['days'];
        },
        needSqftSwitch() {
            return this.dataType === DATA_TYPE_MAP['sqft'];
        },
        minOpts() {
            return this.getOptions('min');
        },
        maxOpts() {
            return this.getOptions('max');
        }
    },
    methods: {
        ...mapActions({
            centerUpdateUiConfigItem: TYPES.CENTER_UPDATE_UI_CONFIG_ITEM
        }),
        updateUiConfig(data) {
            this.centerUpdateUiConfigItem({
                name: this.kee,
                data
            });
        },
        sqftToAcre(val) {
            if (!val && val !== 0) {
                return ''; 
            }
            val = (+val / 43560).toFixed(2).match(/(\d{0,3}\.\d{0,2})/);
            return (val && val[0]) || '';
        },
        acreToSqft(val) {
            if (!val && val !== 0) {
                return ''; 
            }
            return (+val * 43560).toFixed(0);
        },
        getOptions(type) {
            let opts = [];
            if (this.data.mask && this.data.mask.opt) {
                const { min, max } = this.data.mask.opt;
                if (type === 'min') {
                    opts = (min && min.split('\n')) || [];
                } else {
                    opts = (max && max.split('\n')) || [];
                }
                opts = opts.map(o => {
                    // , split
                    let label = o
                        .split('.')
                        .map(v => v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
                        .join('.');
                    if (this.dataType === DATA_TYPE_MAP.money) {
                        label = `${this.currencySymbol} ${label}`;
                    }
                    if (this.dataType === DATA_TYPE_MAP.year) {
                        label = label.replace(',', '');
                    }
                    return { key: o, label };
                });
            }
            return opts;
        }
    }
};
